export const categories = [
  { text: 'ביטחון', category: 'security' },
  { text: 'דוברות ומידע', category: 'pr' },
  { text: 'חינוך', category: 'educational' },
  { text: 'לוגיסטיקה', category: 'logistics' },
  { text: 'רווחה', category: 'social' },
  { text: 'רפואה', category: 'medic' },
  { text: 'אשכולות', category: 'avuka' },

  { text: 'מטה', category: 'headQuaters', isAdmin: true },
]
export const categoriesMap = categories.reduce((acc, curr) => {
  acc[curr.category] = curr
  return acc
}, {})
export const eventType = [
  { text: 'אירוע לוגיסטי', additional: 'פגעי מזג אוויר / שריפה', name: 'fire' },
  {
    text: 'אירוע לוגיסטי קולוסלי',
    additional: 'רעידת אדמה',
    name: 'earthQuake',
  },
  {
    text: 'אירוע בטחוני ביישוב',
    additional: 'חדירה',
    name: 'intruder',
  },
  {
    text: 'אירוע אזרחי ביישוב',
    additional: 'תאונת דרכים',
    name: 'carAccident',
  },
  {
    text: 'אירוע מחוץ לישוב',
    additional: 'תאונת דרכים' + ' / ' + 'פיגוע מחוץ לישוב',
    name: 'outside-event',
  },
  {
    text: 'אירוע רב נפגעים',
    additional: 'פגיעת טילים',
    name: 'bombing',
  },
]
